import React from 'react';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

const FAQCopy = [
  {
    question: 'Why does Zola have a 2.5% transaction fee for honeymoon funds?',
    answer: (
      <>
        All credit card companies charge a transaction fee to transfer money online, and ours is
        just 2.5%. You can have guests pay the fee—we’ve found they’re happy to do so—or absorb it
        on their behalf. Visit{' '}
        <LinkV2
          inline
          className="faq-section-item__description--link"
          href="/faq/115002836332-how-do-we-choose-who-covers-the-2-5-credit-card-processing-fee-for-cash-gifts"
        >
          this page
        </LinkV2>{' '}
        for more info.
      </>
    ),
  },
  {
    question: 'How long will it take to transfer honeymoon funds to our bank?',
    answer: (
      <>
        Your first transfer usually takes up to 10 business days. All following transfers shouldn’t
        take more than 2-4 business days, and we’ll shoot you a confirmation email every time funds
        have been deposited into your bank account.
      </>
    ),
  },
  {
    question: 'Is it really OK to register for cash? How can we make it feel more personal?',
    answer: (
      <>
        Absolutely! Your family and friends want to give you gifts you want. We recommend splitting
        large funds up into smaller, more personalized ones. Guests will love contributing to
        specific things and experiences you two care about. For more, visit this{' '}
        <LinkV2
          inline
          className="faq-section-item__description--link"
          href="/expert-advice/50-fun-and-useful-ways-to-use-your-wedding-cash-fund"
        >
          Expert Advice post
        </LinkV2>
      </>
    ),
  },
  {
    question: 'How do guests contribute to our honeymoon funds?',
    answer:
      'When you add a honeymoon fund to your Zola registry, you can choose to let guests contribute what they want or contribute fixed amounts. Then, like any other online store, they’ll go through the checkout process using their credit cards, PayPal, or Venmo to contribute to your fund.',
  },
  {
    question: 'Can we hide the total amount of a honeymoon fund from guests?',
    answer:
      'Yes! When you create a honeymoon fund and let guests contribute what they want, you can choose to hide the total amount you’re hoping to receive. If a guest tries to contribute more than this total, they’ll be prompted to contribute a lower amount.',
  },
  {
    question: 'Does Zola automatically deposit honeymoon fund contributions into our bank account?',
    answer:
      'No. We’ll notify you every time you receive a contribution towards one of your honeymoon funds. You can transfer your funds to your bank account whenever you want.',
  },
  {
    question: 'Can we register for cash gifts and classic gifts?',
    answer:
      'Definitely! Zola is the only place where you have total flexibility to register for everything you want. Add gifts, experiences, and honeymoon funds from our store, add gifts from other stores, and add a registry from another store. All your gifts will live on one convenient page for guests.',
  },
  {
    question: 'Can we use honeymoon fund contributions to purchase gifts from the Zola store?',
    answer: (
      <>
        Yes! When you receive contributions to your honeymoon funds, you’ll have the option to
        transfer them to your bank account or convert them to Zola store credit and receive a 5%
        bonus. You can then spend that credit on any of the 80,000 gifts in our store or in the{' '}
        <LinkV2
          inline
          className="faq-section-item__description--link"
          href="/shop/category/wedding-shop"
        >
          Wedding Boutique
        </LinkV2>
        .
      </>
    ),
  },
];

export default FAQCopy;
